// #region CONFIG
// Static UI configuration and endpoint field bindings for the BOstageR Dashboard.

export const DASHBOARD_METRIC_CARDS = [
    {
        id: "orders",
        title: "ORDERS",
        dataKey: "orders",
        items: [
            { id: "new", dataKey: "new", label: "NEW" },
            { id: "ready", dataKey: "ready", label: "READY" },
            { id: "pending", dataKey: "pending", label: "PEND", tone: "warning" },
            { id: "failed", dataKey: "failed", label: "FAILED", tone: "danger" }
        ],
        actions: [{ id: "check", label: "CHECK", route: "/orders" }]
    },
    {
        id: "reports",
        title: "REPORTS",
        dataKey: "reports",
        items: [
            { id: "ready", dataKey: "ready", label: "READY" },
            { id: "pending", dataKey: "pending", label: "PENDING", tone: "warning" },
            { id: "reserved", dataKey: "reserved", label: "RESERVED", tone: "warning" }
        ],
        actions: [{ id: "check", label: "CHECK", route: "/buying-intel" }]
    },
    {
        id: "invites-and-requests",
        title: "INVITES AND REQUESTS",
        dataKey: "invitesAndRequests",
        items: [
            { id: "new-invites", dataKey: "newInvites", label: "NEW INVITES" },
            { id: "new-requests", dataKey: "newRequests", label: "NEW REQUESTS" }
        ],
        actions: [
            { id: "check-invites", label: "CHECK INVITES", route: "/labelbrands/invitations" },
            { id: "check-requests", label: "CHECK REQUESTS", route: "/labelbrands/requests" }
        ]
    },
    {
        id: "label-brands",
        title: "LABEL BRANDS",
        dataKey: "labelBrands",
        items: [
            { id: "total", dataKey: "total", label: "TOTAL" },
            { id: "linked", dataKey: "linked", label: "LINKED" },
            { id: "pending", dataKey: "pending", label: "PENDING", tone: "warning" }
        ],
        actions: [{ id: "check", label: "CHECK", route: "/labelbrands/connections" }]
    },
    {
        id: "stores",
        title: "STORES",
        dataKey: "stores",
        items: [
            { id: "total", dataKey: "total", label: "TOTAL" },
            { id: "pos-on", dataKey: "posOn", label: "POS ON", tone: "warning" },
            { id: "pos-off", dataKey: "posOff", label: "POS OFF", tone: "danger" }
        ],
        actions: [{ id: "check", label: "CHECK", route: "/stores" }]
    }
];

export const DASHBOARD_HERO_CONFIG = {
    greetingPrefix: "What can I do for you,",
    defaultUserName: "-",
    inputPlaceholder: "Ask nanaBO to create a buying report...",
    selectorLabel: "Work",
    gradientBackground:
        "var(--botag-gradient, linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), linear-gradient(214deg, #60E25D 21.37%, #6123E4 56.62%, #5AC3FE 77.68%, #2FF 136.72%))"
};
// #endregion
